import { render, staticRenderFns } from "./BigCard.vue?vue&type=template&id=d5947a3e"
import script from "./BigCard.vue?vue&type=script&lang=js"
export * from "./BigCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports